import api from './api';

// Get all stylings for a timeline
const getStylings = async (timelineId) => {
  const response = await api.get(`/api/timelines/${timelineId}/stylings`);
  return response.data;
};

// Create a new styling
const createStyling = async (timelineId, stylingData) => {
  const response = await api.post(`/api/timelines/${timelineId}/stylings`, stylingData);
  return response.data;
};

// Update a styling
const updateStyling = async (stylingId, stylingData) => {
  const response = await api.put(`/api/stylings/${stylingId}`, stylingData);
  return response.data;
};

// Delete a styling
const deleteStyling = async (stylingId) => {
  const response = await api.delete(`/api/stylings/${stylingId}`);
  return response.data;
};

const stylingService = {
  getStylings,
  createStyling,
  updateStyling,
  deleteStyling,
};

export default stylingService; 